import React from "react";
import { View, ScrollView } from "react-native";
import { DEVICE_SIZES, useDeviceSize } from "rn-responsive-styles";
import Skeletons from "./Skeletons";

const PurchaseScreenSkeleton = () => {
  const deviceSize = useDeviceSize();

  const isDesktop =
    deviceSize === DEVICE_SIZES.EXTRA_LARGE_DEVICE ||
    deviceSize === DEVICE_SIZES.LARGE_DEVICE ||
    deviceSize === DEVICE_SIZES.MEDIUM_DEVICE;

  const isMobile =
    deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS;

  return (
    <View
      style={{
        flex: 1,
        paddingHorizontal: "3.5%",
        paddingTop: "2.5%",
      }}
    >
      {/* Header Section */}
      <View
        style={{
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <View style={{ flexDirection: "row", alignItems: "center", gap: 12 }}>
          {/* Back Button Skeleton */}
          <Skeletons height={44} width={44} />
          {/* Title Skeleton */}
          <Skeletons
            height={isMobile ? 24 : 40}
            width={isMobile ? 150 : 250}
          />
        </View>
        {/* My Token Balance Card Skeleton */}
        <Skeletons height={75} width={isMobile ? 200 : 591} />
      </View>

      {/* Separator */}
      <View
        style={{
          width: "100%",
          height: 1,
          backgroundColor: "#374151",
          marginTop: 20,
          marginBottom: 0,
        }}
      />

      {/* Content Section */}
      <ScrollView
        style={{
          marginTop: 20,
        }}
        contentContainerStyle={{
          paddingBottom: 40,
        }}
        showsHorizontalScrollIndicator={false}
        showsVerticalScrollIndicator={false}
      >
        {isDesktop ? (
          <>
            {/* First Row - 4 Token Packages */}
            <View
              style={{
                flexDirection: "row",
                gap: 25,
              }}
            >
              {[1, 2, 3, 4].map((item) => (
                <Skeletons key={item} height={140} width={264} />
              ))}
            </View>

            {/* Second Row - 2 Token Packages */}
            <View
              style={{
                flexDirection: "row",
                gap: 25,
                marginTop: 20,
                marginBottom: 30,
              }}
            >
              {[5, 6].map((item) => (
                <Skeletons key={item} height={140} width={264} />
              ))}
            </View>
          </>
        ) : (
          /* Mobile Grid Layout */
          <View
            style={{
              flexDirection: "row",
              flexWrap: "wrap",
              marginBottom: 30,
            }}
          >
            {[1, 2, 3, 4, 5, 6].map((item) => (
              <View
                key={item}
                style={{
                  width: "50%",
                  padding: 5,
                }}
              >
                <Skeletons height={isMobile ? 120 : 140} width={"100%"} />
              </View>
            ))}
          </View>
        )}

        {/* Token Information Section */}
        <View
          style={{
            width: "100%",
            marginTop: 15,
          }}
        >
          <Skeletons
            height={145}
            width={isMobile ? "100%" : 650}
            style={{ marginBottom: 15 }}
          />

          {/* Footer Section */}
          <Skeletons height={isMobile ? 200 : 90} width={"100%"} />
        </View>
      </ScrollView>
    </View>
  );
};

export default PurchaseScreenSkeleton;
